"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutCell = void 0;
var _pixi = require("pixi.js");
var _Anchor = require("./Anchor");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LayoutCell = exports.LayoutCell = /*#__PURE__*/function () {
  function LayoutCell(x, y, xPos, yPos, width, height, parent) {
    var _this = this;
    var debugMode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    _classCallCheck(this, LayoutCell);
    _defineProperty(this, "_x", void 0);
    _defineProperty(this, "_y", void 0);
    _defineProperty(this, "_xPos", void 0);
    _defineProperty(this, "_yPos", void 0);
    _defineProperty(this, "_width", void 0);
    _defineProperty(this, "_height", void 0);
    _defineProperty(this, "_graphics", void 0);
    _defineProperty(this, "_mask", void 0);
    _defineProperty(this, "_scale", void 0);
    _defineProperty(this, "_anchor", void 0);
    _defineProperty(this, "_autoScale", void 0);
    _defineProperty(this, "DEBUG_MODE", void 0);
    _defineProperty(this, "getWidth", function () {
      return _this._width;
    });
    _defineProperty(this, "getHeight", function () {
      return _this._height;
    });
    _defineProperty(this, "getX", function () {
      return _this._x;
    });
    _defineProperty(this, "getY", function () {
      return _this._y;
    });
    _defineProperty(this, "getCenter", function () {
      return new _pixi.Point(_this._xPos + _this._width / 2, _this._yPos + _this._height / 2);
    });
    _defineProperty(this, "getYpos", function () {
      return _this._yPos;
    });
    _defineProperty(this, "getXpos", function () {
      return _this._xPos;
    });
    this._scale = 1;
    this._x = x;
    this._y = y;
    this._anchor = _Anchor.Anchor.CENTER;
    this._autoScale = true;
    this.DEBUG_MODE = debugMode;
    if (this.DEBUG_MODE) {
      this._graphics = new _pixi.Graphics();
      this._graphics.name = x + ':' + y;
      this._mask = new _pixi.Graphics();
      this._graphics.interactive = true;
      this._graphics.on('click', function () {
        return _this.onClick();
      });
      this.update(x, y, xPos, yPos, width, height);
      parent.addChild(this._graphics);
    } else {
      this.update(x, y, xPos, yPos, width, height);
    }
  }
  return _createClass(LayoutCell, [{
    key: "onClick",
    value: function onClick() {
      console.log(this);
    }
  }, {
    key: "update",
    value: function update(x, y, xPos, yPos, width, height) {
      this._x = x;
      this._y = y;
      this._xPos = xPos;
      this._yPos = yPos;
      this._width = width;
      this._height = height;
      if (this.DEBUG_MODE) {
        this._graphics.clear();
        this._graphics.beginFill(0x00FF00);
        this._graphics.lineStyle(0, 0xF1C232);
        this._graphics.drawRect(xPos, yPos, width, height);
        this._mask.clear();
        this._mask.lineStyle(1, 0x00FF00);
        this._mask.drawRect(xPos, yPos, width, height);
        this._graphics.mask = this._mask;
        this._graphics.hitArea = this._graphics.getBounds();
      }
    }
  }, {
    key: "getCenterPos",
    value: function getCenterPos() {
      return {
        x: this._xPos + this._width / 2,
        y: this._yPos + this._height / 2
      }; //this.assignPos(this._xPos + this._width / 2, this._yPos + this._height / 2);
    }
  }, {
    key: "getTopCenterPos",
    value: function getTopCenterPos() {
      return {
        x: this._xPos + this._width / 2,
        y: this._yPos
      };
    }
  }, {
    key: "getTopLeft",
    value: function getTopLeft() {
      return {
        x: this._xPos,
        y: this._yPos
      };
    }
  }, {
    key: "getTopRight",
    value: function getTopRight() {
      return {
        x: this._xPos + this._width,
        y: this._yPos
      };
    }
  }, {
    key: "getBottomLeft",
    value: function getBottomLeft() {
      return {
        x: this._xPos,
        y: this._yPos + this._height
      };
    }
  }, {
    key: "getBottomRight",
    value: function getBottomRight() {
      return {
        x: this._xPos + this._width,
        y: this._yPos + this._height
      };
    }
  }]);
}();
//# sourceMappingURL=LayoutCell.js.map